import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../../api/authService";
import { useToast } from "../atoms/Toast";
// import logo from "../../logo.svg";

const RegisterForm = ({ onRegister }) => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
  await register(form);
  setSuccess(true);
  toast?.success?.('Registration successful');
  onRegister && onRegister();
  navigate('/');
    } catch (err) {
      setError(err.message || "Registration failed");
      toast?.error?.(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen justify-between">
      <div className="flex-1 flex items-center justify-center">
        <form onSubmit={handleSubmit} className="mx-auto w-full max-w-md p-8 bg-white rounded-xl shadow-lg flex flex-col items-center">
          <img
                src="/logo.svg"
                alt="ModStack"
                className="h-16 w-auto"
              />
          <h1 className="text-2xl font-bold mb-1 text-center">Create your account</h1>
          <p className="text-gray-500 mb-6 text-center">Start building and sharing components.</p>
          {error && <div className="text-red-600 text-sm mb-2 w-full text-center">{error}</div>}
          {success && <div className="text-green-600 text-sm mb-2 w-full text-center">Registration successful! You can now log in.</div>}
          <div className="w-full mb-3">
            <label className="block mb-1 font-medium">First Name</label>
            <input
              type="text"
              name="firstName"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              value={form.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full mb-3">
            <label className="block mb-1 font-medium">Last Name</label>
            <input
              type="text"
              name="lastName"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              value={form.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full mb-3">
            <label className="block mb-1 font-medium">Email</label>
            <input
              type="email"
              name="email"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full mb-6">
            <label className="block mb-1 font-medium">Password</label>
            <input
              type="password"
              name="password"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-purple-600 text-white py-2 rounded-lg font-semibold hover:bg-purple-700 transition disabled:opacity-50 mb-3"
            disabled={loading}
          >
            {loading ? "Registering..." : "Register"}
          </button>
          <div className="text-center text-sm text-gray-600">
            Already have an account? <a href="/login" className="text-purple-600 hover:underline">Sign in</a>
          </div>
        </form>
      </div>
      <footer className="w-full text-center text-xs text-gray-400 py-6 flex flex-col gap-2">
        <div>
          &copy; 2025 ModStack &nbsp; &bull; &nbsp;
          <a href="/privacy" className="hover:underline">Privacy Policy</a> &nbsp; &bull; &nbsp;
          <a href="/terms" className="hover:underline">Terms of Service</a>
        </div>
      </footer>
    </div>
  );
};

export default RegisterForm;
